import React, { FC, useEffect, useState } from 'react';
import { Button, Tooltip, App } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

export interface ExportButtonProps extends WithTranslation {
  onExport: () => void;
  maxItemsCount?: number;
  itemsCount?: number;
  tooltip?: string;
  alertMessage?: string;
}

const ExportButton: FC<ExportButtonProps> = ({ t, onExport, maxItemsCount, itemsCount, tooltip, alertMessage: modalMessage }) => {
  const [max, setMax] = useState(maxItemsCount ?? Number.MAX_VALUE);
  const [current, setCurrent] = useState(itemsCount ?? Number.MIN_VALUE);
  const { modal } = App.useApp();

  useEffect(() => {
    if (itemsCount !== current) {
      setCurrent(itemsCount ?? Number.MIN_VALUE);
    }

    if (maxItemsCount !== max) {
      setMax(maxItemsCount ?? Number.MAX_VALUE);
    }
  }, [itemsCount, maxItemsCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const onClick = () => {
    if (current > max) {
      modal.confirm({
        okButtonProps: { style: { width: 100 } },
        cancelButtonProps: { type: 'default', style: { width: 100 } },
        title: modalMessage ? modalMessage : t('ExportingVeryLargeNumberOfItems'),
        onOk: onExport,
      });
    } else onExport();
  };

  return (
    <>
      <Tooltip placement="top" title={tooltip || t('Export')}>
        <Button
          style={{ width: 56, height: 56, borderRadius: 2, fontSize: 16, color: '#ab162b', borderColor: '#b83542' }}
          icon={<DownloadOutlined />}
          onClick={onClick}
        />
      </Tooltip>
    </>
  );
};

export default withTranslation()(ExportButton);
